import { render } from "./CompanyShow.vue?vue&type=template&id=edcaf920"
import script from "./CompanyShow.vue?vue&type=script&lang=js"
export * from "./CompanyShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__